module.exports = __webpack_public_path__ + "static/media/splash.b6b04eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/splash.png
// module id = 197
// module chunks = 0